<template>
    <artwork-file-option
        :is-selected="isSelected"
        :label="label"
        :file="file"
        @select="$refs.customInput.click()"
    >
        <div class="artwork">
            <input
                ref="customInput"
                type="file"
                class="artwork-input"
                :accept="artworkFileAllowedExtensions.join(',')"
                @change="event => $emit('select', event.target.files[0])"
            >

            <transition name="fade" mode="out-in">
                <div
                    v-if="file === null"
                    class="artwork-custom-placeholder"
                >
                    <i class="far fa-cloud-upload artwork-custom-icon" />
                </div>

                <artwork-file-preview
                    v-else
                    :file="file"
                />
            </transition>
        </div>
    </artwork-file-option>
</template>
<script>
import ArtworkFileOption from './ArtworkFileOption';
import ArtworkFilePreview from './ArtworkFilePreview';
import { artworkFileAllowedExtensions } from '@/utils/config/episodeOptions';

export default {
    components: {
        ArtworkFileOption,
        ArtworkFilePreview,
    },

    props: {
        isSelected: {
            default: false,
            type: Boolean,
        },

        label: {
            required: true,
            type: String,
        },

        file: {
            default: null,
            type: [String, File],
        },
    },

    data: () => ({
        artworkFileAllowedExtensions,
    }),
};
</script>
